var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.396448 0.436365C0.442872 0.389899 0.497997 0.353038 0.558675 0.327889C0.619352 0.30274 0.68439 0.289795 0.750073 0.289795C0.815756 0.289795 0.880794 0.30274 0.941472 0.327889C1.00215 0.353038 1.05727 0.389899 1.1037 0.436365L4.1037 3.43637C4.15016 3.48279 4.18702 3.53791 4.21217 3.59859C4.23732 3.65927 4.25027 3.72431 4.25027 3.78999C4.25027 3.85567 4.23732 3.92071 4.21217 3.98139C4.18702 4.04207 4.15016 4.09719 4.1037 4.14362L1.1037 7.14362C1.05726 7.19005 1.00213 7.22689 0.941454 7.25202C0.880779 7.27716 0.815747 7.29009 0.750073 7.29009C0.684399 7.29009 0.619368 7.27716 0.558693 7.25202C0.498018 7.22689 0.442887 7.19005 0.396448 7.14362C0.350009 7.09718 0.313172 7.04205 0.28804 6.98137C0.262907 6.92069 0.249972 6.85566 0.249972 6.78999C0.249972 6.72432 0.262907 6.65928 0.28804 6.59861C0.313172 6.53793 0.350009 6.4828 0.396448 6.43637L3.04282 3.78999L0.396448 1.14362C0.349983 1.09719 0.313121 1.04207 0.287972 0.981389C0.262823 0.920711 0.249878 0.855673 0.249878 0.78999C0.249878 0.724307 0.262823 0.659269 0.287972 0.598592C0.313121 0.537914 0.349983 0.482789 0.396448 0.436365Z",
    fill: "#F3F3F3",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArw);
export default __webpack_public_path__ + "static/media/right_arw.41bb258bb9ee4d07048dd4fc6802e990.svg";
export { ForwardRef as ReactComponent };